import accountingClientsAPI from "../../api/accountingClientsAPI";

/**
 * Client form save — the part wrapped by useGuardedMutation.
 *
 * Throws on failure, so a failed or dropped save keeps its Idempotency-Key and
 * a retry replays safely (the hook rotates the key only after success).
 *
 * Key lifecycle: the axios interceptor hands the pending key to the FIRST
 * POST/PUT only — create/update. The seed-tax-accounts call goes out without a
 * key, so it always executes. After a 4xx the key is kept; that is safe because
 * the backend caches 2xx only and rejects a reused key whose body changed
 * (IDEMPOTENCY_KEY_REUSE), so an edited resubmit never replays a stale error.
 *
 * Returns the success message to show.
 */
export default async function saveAccountingClient({ isEdit, id, payload }) {
  if (isEdit) {
    await accountingClientsAPI.update(id, payload);
    return "Client updated successfully";
  }

  const res = await accountingClientsAPI.create(payload);

  // Support any backend response shape
  const createdClient =
    res?.data?.data || res?.data?.client || res?.data || null;
  const createdClientId = createdClient?._id;

  // AUTO CREATE TAX ACCOUNTS
  if (createdClientId) {
    await accountingClientsAPI.seedTaxAccounts(createdClientId, {
      taxObligations: payload.taxObligations,
    });
  }

  return "Client created successfully. COA + Tax accounts ready 🎉";
}
